module.exports = __webpack_public_path__ + "img/griffin-the-invisible-man.5eb4e80a.jpg";